<template>
	<nav class="partner-integrations-sidebar">
		<router-link
			:to="{ name: 'operational-partner-integrations' }"
			class="partner-integrations-sidebar-link"
		>
			<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="currentColor"><path d="M729.33-520q-9.66-47.67-34.33-87.67-24.67-40-64.33-74.33v115.33H564V-800h233.33v66.67H673.67q47 40 81.16 96.66Q789-580 797-520h-67.67ZM584.67-266.67h228.66v-106.66H584.67v106.66ZM571.33-200q-22.22 0-37.77-15.56Q518-231.11 518-253.33v-133.34q0-22.22 15.56-37.77Q549.11-440 571.33-440h255.34q22.22 0 37.77 15.56Q880-408.89 880-386.67v133.34q0 22.22-15.56 37.77Q848.89-200 826.67-200H571.33Zm-406.66 40v-66.67h123Q228-273.33 194-334.33T160-478q0-104 62-190.17Q284-754.33 391.33-786v69.33Q320.67-691 273.67-625.83t-47 147.83q0 60.46 25.5 111.39 25.5 50.94 79.16 88.61v-115.33H398V-160H164.67ZM478-80v-66.67h442V-80H478Zm106.67-186.67v-106.66 106.66Z"/></svg>
		</router-link>
		<!-- <router-link
			:to="{ name: 'operational-partner-integrations-action', params: { action: 'logs' } }"
			class="partner-integrations-sidebar-link"
		>
			<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="currentColor"><path d="M128-160v-66.67h118.67l-14.67-14q-57.33-55.33-82-116-24.67-60.66-24.67-120 0-109.66 63.84-195.83Q253-758.67 356.67-790v69.33Q282-692 237-625.17q-45 66.84-45 148.5 0 49.67 17.33 94.84 17.34 45.16 57.34 82.5L290-278v-110.67h66.67V-160H128Zm352-121.33q-13.67 0-23.5-9.84-9.83-9.83-9.83-23.5 0-13.66 9.83-23.5Q466.33-348 480-348t23.5 9.83q9.83 9.84 9.83 23.5 0 13.67-9.83 23.5-9.83 9.84-23.5 9.84Zm-32-152v-246h66.67v246H448Zm155.33 264v-70q74.67-28 119.67-94.84 45-66.83 45-148.5 0-51-17.67-96.16-17.66-45.17-57-81.84L670-682v110.67h-66.67V-800H832v66.67H712.67l15.33 14q57.67 54.33 82.17 115.5 24.5 61.16 24.5 121.16 0 109-64.17 195.5T603.33-169.33Z"/></svg>
		</router-link> -->
		<router-link
			:to="{ name: 'operational-partner-integrations-action', params: { action: 'crawler-executions' } }"
			class="partner-integrations-sidebar-link"
		>
			<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="currentColor"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Z"/></svg>
		</router-link>
		<router-link
			:to="{ name: 'operational-partner-integrations-action', params: { action: 'crawler-errors' } }"
			class="partner-integrations-sidebar-link"
		>
			<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="currentColor"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm-40-120h80v-80h-80v80Zm0-160h80v-240h-80v240Z"/></svg>
		</router-link>
	</nav>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  
  import CredentialService from "@/services/CredentialService.js";
  
  export default {
	name: "MenuPartnerIntegrationsSidebar",
	components: {
	},
	methods: {
	  ...mapActions(["checkPrivilege"]),
	  hasPrivilege(privilege) {
		return CredentialService.hasPrivilege(privilege);
	  },
	},
	computed: {},
	created() {},
	mounted() {
	  this.checkPrivilege({ privilege: "CRM", router: this.$router });
	},
  };
  </script>
  
  <style scoped>
  .partner-integrations-sidebar {
	height: calc(100vh - 152px);
	overflow: hidden;
	flex: 0 0 60px;
	width: 60px;
	border-right: 1px solid #dee2e6;
	background-color: white;
	display: flex;
	flex-direction: column;
  }
  
  .partner-integrations-sidebar-link {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 60px;
	width: 100%;
	border-bottom: 1px solid transparent;
	border-top: 1px solid transparent;
	color: #104375;
  }
  
  .partner-integrations-sidebar-link:hover,
  .partner-integrations-sidebar-link.router-link-active {
	background-color: #104375;
	color: white;
	border-color: #104375;
	/* background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  border-top: 1px solid #dee2e6; */
  }
  </style>
  